import { Component, OnInit, Input, AfterViewInit, ViewChild, ChangeDetectorRef, OnDestroy, SimpleChanges, NgZone } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { DevicePilomat } from '../model/devicePilomat';
import { DeviceService } from '../service/device.service';
import { Log } from '../util/log';
import { ControlUser } from '../model/controlUser';
import { UserService } from '../service/user.service';
import { Overlay } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { LinkDeviceOwnerDialogComponent } from '../link-device-owner-dialog/link-device-owner-dialog.component';
import { interval, Observable, Subscription } from 'rxjs';
import { startWith, switchMap } from 'rxjs/operators';
import { DevicePilomatIO } from '../model/devicePilomatIO';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DeviceState } from '../model/deviceState';
import { AccessMethodsEditorComponent } from '../access-methods-editor/access-methods-editor.component';
import { DeviceDetailEditorComponent } from '../device-detail-editor/device-detail-editor.component';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { DeviceStateData } from '../model/deviceStateData';
import { DeviceStatesData } from '../model/deviceStatesData';
import { DateHelper } from '../util/dateHelper';
import { AppComponent } from '../app.component';
import { environment } from 'src/environments/environment';
import { MoveBollardDialogComponent } from '../move-bollard-dialog/move-bollard-dialog.component';
import { PilomatSystemInfo } from '../model/pilomatSystemInfo';
import { DeviceUsersListDialogComponent } from '../device-users-list-dialog/device-users-list-dialog.component';
import { MigrationDialogComponent } from '../migration-dialog/migration-dialog.component';

@Component({
  selector: 'app-device-detail',
  templateUrl: './device-detail.component.html',
  styleUrls: ['./device-detail.component.css']
})
export class DeviceDetailComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild('deviceloader', { static: true }) loader;
  @ViewChild('devicedetailsloader', { static: true }) loaderDetails;

  serial: string;
  reload: Object;
  device: DevicePilomat;
  owner: ControlUser;
  ios: DevicePilomatIO[] = [];
  deviceStatesData: DeviceStateData[] = [];

  // deviceOffline: boolean = false;
  upCycleCounter: DeviceStateData;
  downCycleCounter: DeviceStateData;
  efoCycleCounter: DeviceStateData;
  pressureInvertionCounter: DeviceStateData;
  SafetyInvertionCounter: DeviceStateData;
  raisingTimeoutCounter: DeviceStateData;
  loweringTimeoutCounter: DeviceStateData;
  bollards: DeviceStateData;
  dipSwitchState: DeviceStateData;
  dipSwitchesState: Boolean[] = [false, false, false, false, false, false];

  map: google.maps.Map;
  editMapEnabled: boolean = false;
  mapLat: number;
  mapLng: number;
  mapZoom: number = 12;


  timeInterval: Subscription;
  deviceStateSubscription: Subscription;

  deviceDataSubscription: Subscription;

  userCanDeviceEdit: boolean = false;
  userCanDeviceAction: boolean = false;
  userCanDeviceReboot: boolean = false;
  userCanDeviceViewLogs: boolean = false;

  // position: string;
  // errors: string = "";
  lastUpdateStr: string;
  dateError: boolean = true;

  private aliasPermissionCache: Map<string, boolean> = new Map();

  closeDialogString = $localize`:@@device_detail_close_toast:chiudi `;

  constructor(
    public appComponent: AppComponent,
    private deviceService: DeviceService,
    private userService: UserService,
    private route: ActivatedRoute,
    private location: Location,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private overlay: Overlay,
    private zone: NgZone
  ) {
  }

  ngOnInit(): void {
    this.loader.showLoading();

    this.route.paramMap.subscribe(params => {
      const serial = this.route.snapshot.paramMap.get('serial');
      this.serial = serial;

      this.getDevice(this.serial);

      this.getOwner(this.serial);
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['this.serial']) {
      this.getDevice(this.serial);
      this.getOwner(this.serial);
    }
  }

  ngOnDestroy(): void {

    if (this.timeInterval) {
      this.timeInterval.unsubscribe();
    }

    if (this.deviceStateSubscription) {
      this.deviceStateSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {

    // setTimeout(() => {

    //   const serial = this.route.snapshot.paramMap.get('serial');
    //   this.serial = serial;

    //   this.getDevice(this.serial);

    //   this.getOwner(this.serial);

    // });
  }


  getDevice(serial: string): void {
    this.deviceService.getDevice(serial).subscribe(device => {

      this.device = device;

      this.mapLat = this.device.latitude;
      this.mapLng = this.device.longitude;

      //faccio un prime getDeviceState per avere i dati all'avvio della pagina
      //in seguito faccio il primo getDeviceStateData, per i successivi ci penserà getDeviceState una volta terminato
      this.getDeviceState();
      this.getDeviceStateData();
      this.checkPermissions();
      this.isVpnConnected();

      //timeInterval lo ripeterà ogni 6 secondi (parte 6 secondi dopo il caricamento della pagina)
      this.timeInterval = interval(6000).subscribe((res) => {
        this.getDeviceState();
      });

      this.loader.hideLoading();
      this.loaderDetails.hideLoading();

      this.cdRef.detectChanges();

    });
  }


  async checkPermissions() {
    const isAlias = await this.appComponent.isAlias();
    if (isAlias) {

      Log.debug("\n\n\n\n IS USER ALIAS \n\n\n\n");

      this.userCanDeviceEdit = await this.checkAliasPermissions("DeviceEdit");
      this.userCanDeviceAction = await this.checkAliasPermissions("DeviceAction");
      this.userCanDeviceReboot = await this.checkAliasPermissions("DeviceReboot");
      this.userCanDeviceViewLogs = await this.checkAliasPermissions("DeviceViewLogs");
    } else {

      Log.debug("\n\n\n\n USER NOT ALIAS \n\n\n\n");

      this.userCanDeviceEdit = true;
      this.userCanDeviceAction = true;
      this.userCanDeviceViewLogs = true;

      //reboot visibile solo a service e admin:

      if (this.isService() || this.isAdmin()) {
        this.userCanDeviceReboot = true;
      }

    }
  }

  async checkAliasPermissions(feature: string): Promise<boolean> {
    return this.userService.checkAliasPermissions(feature);
  }

  isVpnConnected(): void {
    this.deviceService.getIsVpnCreated(this.device.routerSerial).subscribe(data => {

      Log.debug("\n\n\n\getIsVpnCreated:");
      Log.debug(data);

      if (data) {
        this.deviceService.getIsVpnConnected(this.device.routerSerial).subscribe(data => {

          Log.debug("\n\n\n\getIsVpnConnected:");
          Log.debug(data);

          if (data) {
            //vpn esistente e connessa
            this.device.vpnState = 1;
          } else {
            //vpn esistente, ma non connessa
            this.device.vpnState = 0;
          }

          this.cdRef.detectChanges();
        });
      } else {
        //vpn non esistente
        this.device.vpnState = -1;
      }

      this.cdRef.detectChanges();
    });
  }

  getDeviceState() {
    this.deviceStateSubscription = this.deviceService.getDeviceState(this.serial).subscribe((response) => {
      this.device.errors = "";
      this.updateDeviceState(response);
      this.deviceStateSubscription.unsubscribe();
      this.getDeviceStateData();
    }, err => {
      if (err.error.errors[0].message == "io-lowered-not-found") {
        this.device.errors = $localize`:@@device_detail_device_error_switch_not_configured:Contatto basso non configurato`;
      } else if (err.error.errors[0].message == "IOLoweredNotConfigured") {
        this.device.errors = $localize`:@@device_detail_device_error_switch_not_configured:Contatto basso non configurato`;
      }

      this.device.stateString = $localize`:@@device_detail_device_error:Errore`;
      this.device.showErrorState();
      this.deviceStateSubscription.unsubscribe();
      this.getDeviceStateData();
    });
  }

  getDeviceStateData() {
    this.deviceDataSubscription = this.deviceService.getDeviceStateData(this.serial).subscribe((response) => {
      // this.device.errors = "";
      this.updateDeviceStateData(response);
      this.deviceDataSubscription.unsubscribe();
    });
  }


  isService(): boolean {
    return this.appComponent.isService();
  }

  isAdmin(): boolean {
    return this.appComponent.isAdmin();
  }

  isPilomatDev(): boolean {
    if (environment.onecontrol.serverFolder == "pilomatdev") {
      return true;
    } else {
      return false;
    }
  }

  updateDeviceStateData(stateData: DeviceStateData[]) {

    this.upCycleCounter = new DeviceStateData();
    this.dipSwitchState = new DeviceStateData();
    this.downCycleCounter = new DeviceStateData();
    this.pressureInvertionCounter = new DeviceStateData();
    this.bollards = new DeviceStateData();
    this.loweringTimeoutCounter = new DeviceStateData();
    this.efoCycleCounter = new DeviceStateData();
    this.SafetyInvertionCounter = new DeviceStateData();
    this.raisingTimeoutCounter = new DeviceStateData();


    for (let i = 0; i < stateData.length; i++) {
      if (stateData[i].type == 'sta-cyup') {
        this.upCycleCounter = stateData[i];
      } else if (stateData[i].type == 'sta-dip') {
        this.dipSwitchState = stateData[i];
      } else if (stateData[i].type == 'sta-cydo') {
        this.downCycleCounter = stateData[i];
      } else if (stateData[i].type == 'sta-invp') {
        this.pressureInvertionCounter = stateData[i];
      } else if (stateData[i].type == 'sta-bol') {
        this.bollards = stateData[i];
      } else if (stateData[i].type == 'sta-tlow') {
        this.loweringTimeoutCounter = stateData[i];
      } else if (stateData[i].type == 'sta-cyefo') {
        this.efoCycleCounter = stateData[i];
      } else if (stateData[i].type == 'sta-invs') {
        this.SafetyInvertionCounter = stateData[i];
      } else if (stateData[i].type == 'sta-tris') {
        this.raisingTimeoutCounter = stateData[i];
      }
    }


    let dipSwitchStateBinary = this.dipSwitchState.value.toString(2);

    if (dipSwitchStateBinary.length == 6) {
      this.dipSwitchesState[5] = true;
    } else {

      if (dipSwitchStateBinary.length == 4) {
        dipSwitchStateBinary = '0'.concat(dipSwitchStateBinary);
      } else if (dipSwitchStateBinary.length == 3) {
        dipSwitchStateBinary = '00'.concat(dipSwitchStateBinary);
      } else if (dipSwitchStateBinary.length == 2) {
        dipSwitchStateBinary = '000'.concat(dipSwitchStateBinary);
      } else if (dipSwitchStateBinary.length == 1) {
        dipSwitchStateBinary = '0000'.concat(dipSwitchStateBinary);
      }

      for (let i = 0; i < 5; i++) {
        if (dipSwitchStateBinary.charAt(i) == '1') {
          this.dipSwitchesState[4 - i] = false;
        } else {
          this.dipSwitchesState[4 - i] = true;
        }
      }
      this.dipSwitchesState[5] = false;
    }

    this.cdRef.detectChanges();
  }

  getOwner(serial: string): void {

    this.loaderDetails.showLoading();

    this.userService.getOwnerOfDevice(serial).subscribe(owner => {

      if (owner) {
        this.owner = owner;
      } else {
        Log.debug("NO OWNERRRRR")
      }


      this.loaderDetails.hideLoading();
      this.cdRef.detectChanges();

    }, error => {

      this.loaderDetails.hideLoading();
      // this.loaderDetails.showError();

      this.cdRef.detectChanges();
      this.loaderDetails.hideLoading();
    });

  }

  modifyDeviceDetails() {
    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(DeviceDetailEditorComponent, {
      width: '800px',
      data: { device: this.device },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.loader.showLoading();
      this.getDevice(this.device.serial);
      this.cdRef.detectChanges();
    });
  }

  unlinkOwner(): void {
    let message = $localize`:@@device_detail_unlink_device_from_owner_confirm:  Scollegare il dispositivo dal gestore?`;
    let confirmMessage = $localize`:@@device_detail_unlink_device_from_owner_confirm_yes:  Sì, scollega`;
    let cancelMessage = $localize`:@@device_detail_unlink_device_from_owner_confirm_no:  No, annulla`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '450px',
      data: { message, confirmMessage, cancelMessage },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      Log.debug(response);
      if (response) {
        this.deviceService.unlinkDeviceFromOwner(this.device.serial, this.owner.uid.toString()).subscribe(res => {
          Log.debug('Device unlinked , ' + res);
          window.location.reload();
        }, error => {
          Log.debug('Device unlinked , ' + error);
        });
      }
    });
  }

  sendOpenCommand(): void {

    if (this.device.deviceOffline) {

      this.deviceOfflineDialog();

    } else {
      let message = "";

      if (this.device.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BARRIER || this.device.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
        message = $localize`:@@device_detail_send_lowering_command_confirm:  Desideri inviare il comando di abbassamento?`;
      } else {
        message = $localize`:@@device_detail_send_opening_command_confirm:  Desideri inviare il comando di apertura?`;
      }

      let confirmMessage = $localize`:@@device_detail_send_lowering_command_confirm_yes:  Sì, invia`;
      let cancelMessage = $localize`:@@device_detail_send_lowering_command_confirm_no:  No, annulla`;

      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '400px',
        data: { message, confirmMessage, cancelMessage },
        scrollStrategy,
      });

      dialogRef.afterClosed().subscribe((response) => {

        if (response) {

          this.loader.showLoading();

          this.deviceService.sendOpenCommand(this.device.serial).subscribe(res => {

            this.loader.hideLoading();

            this.cdRef.detectChanges();

            let snackBarRef = this.snackBar.open($localize`:@@device_detail_device_activated:  Dispositivo azionato`, this.closeDialogString, {
              duration: 3000
            });

          }, err => {
            this.loaderDetails.hideLoading();
            this.loader.hideLoading();

            if (err.error.message == "device-offline") {
              this.deviceOfflineDialog();
            } else {
              this.loader.showError();
            }

          });
        }
      });
    }
  }

  sendForcedLowCommand(): void {
    if (this.device.deviceOffline) {

      this.deviceOfflineDialog();

    } else {
      let message = '';
      let confirmMessage = '';
      let cancelMessage = '';
      let initialForceLowState = this.device.forcedLow;

      if (this.device.forcedLow) {
        if (this.device.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD || this.device.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
          message = $localize`:@@device_detail_disable_forced_low_confirm:  Desideri disattivare lo stato di forzato basso?`;
        } else {
          message = $localize`:@@device_detail_disable_forced_open_confirm:  Desideri disattivare lo stato di forzato aperto?`;
        }


        confirmMessage = $localize`:@@device_detail_disable_forced_low_confirm_yes: Sì, disattiva`;
        cancelMessage = $localize`:@@device_detail_disable_forced_low_confirm_no: No, annulla`;
      } else {
        if (this.device.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD || this.device.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
          message = $localize`:@@device_detail_enable_forced_low_confirm:  Desideri attivare lo stato di forzato basso?`;
        } else {
          message = $localize`:@@device_detail_enable_forced_open_confirm:  Desideri attivare lo stato di forzato aperto?`;
        }
        confirmMessage = $localize`:@@device_detail_enable_forced_low_confirm_yes: Sì, attiva`;
        cancelMessage = $localize`:@@device_detail_enable_forced_low_confirm_no: No, annulla`;
      }

      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '400px',
        data: { message, confirmMessage, cancelMessage },
        scrollStrategy,
      });

      dialogRef.afterClosed().subscribe((response) => {

        if (response) {

          this.loaderDetails.showLoading();
          let state = !this.device.forcedLow;

          this.deviceService.sendForcedLowCommand(this.device.serial, state).subscribe(res => {

            this.loaderDetails.hideLoading();

            this.cdRef.detectChanges();

            if (initialForceLowState) {

              if (this.device.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD || this.device.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
                let snackBarRef = this.snackBar.open($localize`:@@device_detail_forced_low_disabled_toast:Disattivazione forzato basso in corso`, this.closeDialogString, {
                  duration: 5000
                });
              } else {
                let snackBarRef = this.snackBar.open($localize`:@@device_detail_forced_open_disabled_toast:Disattivazione forzato aperto in corso`, this.closeDialogString, {
                  duration: 5000
                });
              }
            } else {
              if (this.device.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD || this.device.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
                let snackBarRef = this.snackBar.open($localize`:@@device_detail_forced_low_enabled_toast:Attivazione forzato basso in corso`, this.closeDialogString, {
                  duration: 5000
                });
              } else {
                let snackBarRef = this.snackBar.open($localize`:@@device_detail_forced_open_enabled_toast:Attivazione forzato aperto in corso`, this.closeDialogString, {
                  duration: 5000
                });
              }
            }
          }, err => {
            this.loaderDetails.hideLoading();
            this.loader.hideLoading();

            if (err.error.message == "device-offline") {
              this.deviceOfflineDialog();
            } else {
              this.loader.showError();
            }
          });
        }
      });
    }
  }

  sendCloseCommand(): void {
    if (this.device.deviceOffline) {

      this.deviceOfflineDialog();

    } else {

      let message = $localize`:@@device_detail_send_raise_command_confirm:  Desideri inviare il comando di risalita?`;
      let confirmMessage = $localize`:@@device_detail_send_raise_command_confirm_yes:  Sì, invia`;
      let cancelMessage = $localize`:@@device_detail_send_raise_command_confirm_no:  No, annulla`;

      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '400px',
        data: { message, confirmMessage, cancelMessage },
        scrollStrategy,
      });

      dialogRef.afterClosed().subscribe((response) => {

        if (response) {

          this.loader.showLoading();

          this.deviceService.sendCloseCommand(this.device.serial).subscribe(res => {

            this.loader.hideLoading();

            this.cdRef.detectChanges();

            let snackBarRef = this.snackBar.open($localize`:@@device_detail_device_activated:  Dispositivo azionato`, this.closeDialogString, {
              duration: 3000
            });

          }, err => {
            this.loaderDetails.hideLoading();
            this.loader.hideLoading();

            if (err.error.message == "device-offline") {
              this.deviceOfflineDialog();
            } else {
              this.loader.showError();
            }
          });
        }
      });
    }
  }

  sendSBSCommand(): void {
    if (this.device.deviceOffline) {

      this.deviceOfflineDialog();

    } else {

      // let message = "Desideri inviare il comando di azionamento passo-passo?";
      let message = $localize`:@@device_detail_send_sbs_command_confirm:  Desideri azionare il dispositivo?`;
      let confirmMessage = $localize`:@@device_detail_send_sbs_command_confirm_yes:  Sì, invia`;
      let cancelMessage = $localize`:@@device_detail_send_sbs_command_confirm_no:  No, annulla`;

      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '400px',
        data: { message, confirmMessage, cancelMessage },
        scrollStrategy,
      });

      dialogRef.afterClosed().subscribe((response) => {

        Log.debug(response);

        if (response) {

          this.loaderDetails.showLoading();

          this.deviceService.sendSBSCommand(this.device.serial).subscribe(res => {

            this.loaderDetails.hideLoading();

            this.cdRef.detectChanges();


            let snackBarRef = this.snackBar.open($localize`:@@device_detail_device_activated:  Dispositivo azionato`, this.closeDialogString, {
              duration: 3000
            });

          }, err => {
            this.loaderDetails.hideLoading();
            this.loader.hideLoading();

            if (err.error.message == "device-offline") {
              this.deviceOfflineDialog();
            } else {
              this.loader.showError();
            }
          });
        }
      });
    }
  }

  sendOTACommand(): void {
    if (this.device.deviceOffline) {

      this.deviceOfflineDialog();

    } else {

      // let message = "Desideri inviare il comando di azionamento passo-passo?";
      let message = $localize`:@@device_detail_send_ota_command_confirm:  Desideri aggiornare il dispositivo da remoto?`;
      let confirmMessage = $localize`:@@device_detail_send_ota_command_confirm_yes:  Sì, aggiorna`;
      let cancelMessage = $localize`:@@device_detail_send_ota_command_confirm_no:  No, annulla`;

      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '400px',
        data: { message, confirmMessage, cancelMessage },
        scrollStrategy,
      });

      dialogRef.afterClosed().subscribe((response) => {

        Log.debug(response);

        if (response) {

          this.loaderDetails.showLoading();

          this.deviceService.sendOTACommand(this.device.serial).subscribe(res => {

            this.loaderDetails.hideLoading();

            this.cdRef.detectChanges();


            let snackBarRef = this.snackBar.open($localize`:@@device_detail_device_updating:  Aggiornamento in corso`, this.closeDialogString, {
              duration: 3000
            });

          }, err => {
            this.loaderDetails.hideLoading();
            this.loader.hideLoading();

            if (err.error.message == "device-offline") {
              this.deviceOfflineDialog();
            } else {
              this.loader.showError();
            }
          });
        }
      });
    }
  }

  getDeviceUsers(): void {

    // nel data del dialog non fa mettere parametri separati da punti (es. this.device.serial), raggiro così
    let deviceSerial = this.device.serial;
    let ownerUid = this.owner.uid;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(DeviceUsersListDialogComponent, {
      width: '1200px',
      data: { deviceSerial, ownerUid },
      scrollStrategy,
    });
  }


  sendRebootCommand(): void {
    if (this.device.deviceOffline) {

      this.deviceOfflineDialog();

    } else {

      // let message = "Desideri inviare il comando di azionamento passo-passo?";
      let message = $localize`:@@device_detail_send_reboot_command_confirm:  Desideri riavviare il dispositivo?`;
      let confirmMessage = $localize`:@@device_detail_send_reboot_command_confirm_yes:  Sì, riavvia`;
      let cancelMessage = $localize`:@@device_detail_send_reboot_command_confirm_no:  No, annulla`;

      const scrollStrategy = this.overlay.scrollStrategies.reposition();

      const dialogRef = this.dialog.open(ConfirmDialogComponent, {
        width: '400px',
        data: { message, confirmMessage, cancelMessage },
        scrollStrategy,
      });

      dialogRef.afterClosed().subscribe((response) => {

        Log.debug(response);

        if (response) {

          this.loaderDetails.showLoading();

          this.deviceService.sendRebootCommand(this.device.serial).subscribe(res => {

            this.loaderDetails.hideLoading();

            this.cdRef.detectChanges();


            let snackBarRef = this.snackBar.open($localize`:@@device_detail_device_rebooting:  Riavvio in corso`, this.closeDialogString, {
              duration: 3000
            });

          }, err => {
            this.loaderDetails.hideLoading();
            this.loader.hideLoading();

            if (err.error.message == "device-offline") {
              this.deviceOfflineDialog();
            } else {
              this.loader.showError();
            }
          });
        }
      });
    }
  }

  goBack(): void {
    this.location.back();
  }

  showOwner(): void {

    this.router.navigate(['owner/' + this.owner.uid]);
  }

  onMarkerClicked(device) {

    Log.debug('onMarkerClicked: ' + JSON.stringify(device));

  }

  onInfoWindowClicked(device) {

    Log.debug('onInfoWindowClicked: ' + JSON.stringify(device));

  }

  public mapReadyHandler(map: google.maps.Map): void {
    this.map = map;
    let mapClickListener = this.map.addListener('click', (e: google.maps.MouseEvent) => {
      this.zone.run(() => {
        if (this.isAdmin() && this.editMapEnabled) {
          let message = $localize`:@@device_detail_confirm_placement: Posizionare il dispositivo nel luogo scelto?`;
          let confirmMessage = $localize`:@@device_detail_confirm_placement_yes: Sì, posiziona`;
          let cancelMessage = $localize`:@@device_detail_confirm_placement_no: No, annulla`;

          const scrollStrategy = this.overlay.scrollStrategies.reposition();

          const dialogRef = this.dialog.open(ConfirmDialogComponent, {
            width: '400px',
            data: { message, confirmMessage, cancelMessage },
            scrollStrategy,
          });

          dialogRef.afterClosed().subscribe((response) => {
            if (response) {
              this.editMapEnabled = false;
              this.device.latitude = e.latLng.lat();
              this.device.longitude = e.latLng.lng();
              this.deviceService.updateDeviceDetails(this.device, this.device.serial).subscribe(res => {
              }, err => {
                Log.debug(err);
                // this.loader.showError();
              });
            }
          });
        } else {
          Log.debug('repositioning not allowed');
        }
      });
    });
  }


  // animateMapPanning(newLat: number, newLng : number){

  //   setTimeout(function () { map.setZoom(currentZoom) }, 80);
  // }


  editMap() {

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(MoveBollardDialogComponent, {
      width: '600px',
      data: {},
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response) {
        if (response != 'no data') {
          this.editMapEnabled = true;
          // let wideViewZoom = 8;
          // let closeUpZoom = 14;
          // this.mapZoomWide(wideViewZoom, closeUpZoom, response[0], response[1]);
          this.mapZoom = 18;
          this.map.panTo({ lat: response[0], lng: response[1] });
        } else {
          this.editMapEnabled = true;
        }
      } else {
        this.editMapEnabled = false;
      }
    });
  }

  // mapZoomWide(wideViewZoom, closeUpZoom, newLat, newLng): void {
  //   if (this.mapZoom > wideViewZoom) {
  //     this.mapZoom = this.mapZoom - 0.125;
  //     setTimeout(k => { this.mapZoomWide(wideViewZoom, closeUpZoom, newLat, newLng) }, 25);
  //   } else {
  //     // this.map.panTo({ lat: newLat, lng: newLng });
  //     setTimeout(k => { this.map.panTo({ lat: newLat, lng: newLng }) }, 500);
  //     setTimeout(k => { this.mapZoomIn(closeUpZoom) }, 500);
  //   }
  // }

  // mapZoomIn(closeUpZoom) {
  //   if (this.mapZoom < closeUpZoom) {
  //     this.mapZoom = this.mapZoom + 0.125;
  //     setTimeout(k => { this.mapZoomIn(closeUpZoom) }, 25);
  //   }
  // }


  setOwner(): void {

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(LinkDeviceOwnerDialogComponent, {
      width: '800px',
      data: { device: this.device },
      scrollStrategy
    });

    dialogRef.afterClosed().subscribe(result => {
      this.loaderDetails.showLoading();
      if (!result) {
        this.loaderDetails.hideLoading();
      } else if (result.owner) {

        this.deviceService.linkDeviceToOwner(this.device.serial, result.owner.uid).subscribe(deviceOwnerData => {

          this.loader.hideLoading();
          this.loaderDetails.hideLoading();

          this.reload = new Object();

          let snackBarRef = this.snackBar.open($localize`:@@device_detail_owner_linked:Gestore associato correttamente`, this.closeDialogString, {
            duration: 3000
          });

          this.cdRef.detectChanges();

          this.getOwner(this.device.serial);

        }, error => {

          this.loader.hideLoading();
          this.loaderDetails.hideLoading();
          // this.loader.showError();
        });
      }
    });
  }


  migration() {

    let ownerUid = this.owner.uid;
    let originSerial = this.serial;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(MigrationDialogComponent, {
      width: '400px',
      data: { ownerUid, originSerial },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {

      Log.debug(response);

      if (response) {
        Log.debug("response true;");
      }
    });
  }


  updateDeviceState(deviceState: DeviceState) {

    this.device.updateState(deviceState);

    this.device.deviceOffline = false;

    if (this.device.errors == "") {
      let lastupdate = DateHelper.formatDateFriendlyWithHourValidityCheck(deviceState.dateDate);

      if (lastupdate) {
        this.lastUpdateStr = lastupdate;
        this.dateError = false;

      } else {
        this.lastUpdateStr = "";
        this.dateError = true;

      }

    }

    this.cdRef.detectChanges();
  }


  deviceOfflineDialog() {
    let message = $localize`:@@device_detail_device_offline_message:Il dispositivo è offline. Impossibile inviare il comando.`;
    let header = $localize`:@@device_detail_device_offline_header:Errore`;

    const scrollStrategy = this.overlay.scrollStrategies.reposition();

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      width: '400px',
      data: { message, header },
      scrollStrategy,
    });

    dialogRef.afterClosed().subscribe((response) => {
    });
  }

  isUpDownType() {
    if (this.device.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_BOLLARD || this.device.systemInfo.model == PilomatSystemInfo.DEVICE_PILOMAT_MODEL_ROADBLOCKER) {
      return true;
    } else {
      return false;
    }
  }
}
